import React from 'react';
import { useHistory } from 'react-router'
import styles from './css/Error.module.css';
import { Row, Col, Button, Layout, Menu as AntdMenu } from 'antd';
import * as CONSTANTS from '../../constants/constants';
import { Footer } from "./CorePageContents";

const { Content } = Layout;

export const SystemError = () => {

  let history = useHistory();

  const onClickPrevBack = () => {
    history.push(CONSTANTS.PATH_TOP);
    return <></>;
  }

  return (
    <Layout>
      <Row className={styles.HeaderArea}>
        <Col span={6} className={styles.HeaderlogoArea}>
          <img
            className={styles.LogoStyle}
            src={process.env.PUBLIC_URL + '/header_logo_green.png'}
            alt="スキルマップサイト" />
        </Col>
      </Row>


      <AntdMenu className={styles.HeaderMenu}>
      </AntdMenu>

      <Content>
        <div className={styles.mainMessage}>問題が発生しました</div>
        <br />
        <br />
        <br />
        <div className={styles.subMessage}>
          予期せぬエラーが発生し、処理を正常に完了できませんでした。<br />
          ご迷惑をおかけし、誠に申し訳ございません。
        </div>
        <br />
        <br />
        <Button
          className={styles.sysButton}
          onClick={onClickPrevBack}
        >
          TOPページへ戻る
        </Button>
      </Content>
      <Footer />
    </Layout >
  );
}
